import React, { useState } from 'react';
import { useI18n } from '@whizz/react-i18n';
import type { SystemColorType } from '../../../util/types';
import { Collapse } from '../../../components';
import { Section } from '../../../global';
import { getIconComponent } from '../../../util/reactFunc';
import { GLOBAL_ICONS } from '../../../util/vars';
import { OutcomeStyled, statuses } from './LessonHistoryTable.components';
import { LessonOutcomeStatusKeyEnum as Outcomes } from '@whizz/api-model';

interface KeyItem {
  label: string;
  color: SystemColorType;
  defKey: string;
}

const keyItem = (status: Outcomes, defKey: string): KeyItem => ({
  label: statuses[status].label,
  color: statuses[status].color,
  defKey,
});

const KEY_ITEMS: KeyItem[] = [
  keyItem(Outcomes.PASSED, 'PASSED'),
  keyItem(Outcomes.STATIC, 'STATIC'),
  keyItem(Outcomes.FAILED, 'FAILED'),
  keyItem(Outcomes.JUMPED, 'JUMPED'),
  keyItem(Outcomes.INCOMPLETE, 'INCOMPLETE'),
  keyItem(Outcomes.SCAFFOLD, 'SCAFFOLD'),
];

const StatusKey = (): JSX.Element => {

  const { translate } = useI18n();

  const [ open, setOpen ] = useState(false);

  return (
    <Section>
      <div className={'container'}>
        <div className={'p-3'}>
          <button
            type={'button'}
            className={'flex justify-between items-center w-full apperance-none'}
            onClick={() => setOpen((prev) => !prev)}
          >
            <span className={'flex items-center gap-2'}>
              <span className={'font-bold italic text-lg'}>{translate('pages.HISTORY.STATUS_KEY.TITLE')}</span>
              {getIconComponent('InfoCircle', 'md', 'primary')}
            </span>
            {getIconComponent(GLOBAL_ICONS[open ? 'toggle_on' : 'toggle_off'], 'md', 'primary')}
          </button>
          <Collapse when={open}>
            <div
              className={'pt-3'}
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gridTemplateRows: 'repeat(3, auto)',
                gridAutoFlow: 'column',
                rowGap: 12,
                columnGap: 32,
              }}
            >
              {KEY_ITEMS.map(({ label, color, defKey }) => (
                <div key={defKey} style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                  <OutcomeStyled
                    $color={color}
                    style={{
                      width: 150,
                      flexShrink: 0,
                      padding: '10px 14px',
                      fontSize: 18,
                      lineHeight: 1.2,
                      whiteSpace: 'nowrap',
                      boxSizing: 'border-box',
                    }}
                    className={'rounded text-center font-bold'}
                  >
                    {translate(`pages.HISTORY.OUTCOMES.${label}`)}
                  </OutcomeStyled>
                  <div className={'text-muted'} style={{ fontSize: 18, lineHeight: 1.4 }}>
                    {translate(`pages.HISTORY.STATUS_KEY.${defKey}`)}
                  </div>
                </div>
              ))}
            </div>
          </Collapse>
        </div>
      </div>
    </Section>
  );
};

StatusKey.displayName = 'StatusKey';

export default StatusKey;
